import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { AuthTypes } from 'enums';
import { isEmpty } from 'lib/util';
import {
    createAndPerformStartAuthenticationAction,
    createAndPerformLogoutAction,
    createDisplayProviderDialogAction
} from 'common/actions/authenticationActions';
import { roadblockSelector, isDomesticSelector } from 'common/selectors/appSelector';
import { brandingSelector } from 'common/selectors/pageSelector';
import providerSelector from 'common/selectors/providerSelector';
import ProviderLogo from './ProviderLogo';
import ProviderLogoPlayback from './ProviderLogoPlayback';

class BrandingContainer extends Component {
    constructor(props, context) {
        super(props, context);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleLogoutFromPlaybackPage = this.handleLogoutFromPlaybackPage.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    // for homepage, after user logs out, refresh page to avoid DOM maintainance (since player bundle manipulates DOM directly)
    handleLogout(event) {
        event.preventDefault();
        const { stream, dispatch } = this.props;
        dispatch(createAndPerformLogoutAction(stream))
            .finally(() => {
                window.location = window.location;
            });
    }

    // from the playback page, we're able to logout without refreshing
    handleLogoutFromPlaybackPage(event) {
        event.preventDefault();
        const { stream, dispatch } = this.props;
        dispatch(createAndPerformLogoutAction(stream));
    }

    handleLogin(event) {
        event.preventDefault();
        this.props.dispatch(createAndPerformStartAuthenticationAction(null))
            .then((isAuthenticated) => {
                if (isAuthenticated === false) {
                    this.props.dispatch(createDisplayProviderDialogAction());
                }
            });
    }

    render() {
        const { branding, isDomestic, isMobile, location, providerInfo, roadblock, userAuth } = this.props;
        const loggedIn = (userAuth.indexOf(AuthTypes.MVPD) !== -1 || userAuth.indexOf(AuthTypes.ISP) !== -1);
        const displayLogout = (!isEmpty(providerInfo) && userAuth.indexOf(AuthTypes.MVPD) !== -1);
        const isPlayerPage = location && location.pathname === '/player';
        const hideProviderLogo = (isDomestic && isPlayerPage) || (roadblock && isMobile);
        // different logo for player page, watch logo also visible while authd
        if (isPlayerPage) {
            return (
                <ProviderLogoPlayback
                    displayLogout={displayLogout}
                    handleLogin={this.handleLogin}
                    handleLogout={this.handleLogoutFromPlaybackPage}
                    hideProviderLogo={hideProviderLogo}
                    loggedIn={loggedIn}
                    providerInfo={providerInfo}
                    userAuth={userAuth}
                    branding={isDomestic ? null : branding}
                />
            );
        }

        if (hideProviderLogo) {
            return null;
        }

        return (
            <ProviderLogo
                displayLogout={displayLogout}
                handleLogout={this.handleLogout}
                providerInfo={providerInfo}
                userAuth={userAuth}
                branding={isDomestic ? null : branding}
            />
        );
    }
}

BrandingContainer.propTypes = {
    branding: PropTypes.object,
    stream: PropTypes.object,
    dispatch: PropTypes.func,
    isDomestic: PropTypes.bool,
    isMobile: PropTypes.bool,
    location: PropTypes.object,
    providerInfo: PropTypes.object,
    roadblock: PropTypes.bool,
    userAuth: PropTypes.array
};

BrandingContainer.defaultProps = {
    userAuth: [],
    providerInfo: {}
};

const mapStateToProps = (state) => {
    const { app: { isMobile = false } = {} } = state;
    const { authTypes: userAuth } = state.authentication;
    return {
        branding: brandingSelector(state),
        isDomestic: isDomesticSelector(state),
        isMobile,
        providerInfo: providerSelector(state),
        roadblock: roadblockSelector(state),
        userAuth
    };
};

export default connect(mapStateToProps)(BrandingContainer);



// WEBPACK FOOTER //
// ./app/webapp/branding/BrandingContainer.js